import firebase from 'firebase/app';
import 'firebase/database';
import { ChatAdapter } from './ChatAdapter';

/**
 * FirebaseChatAdapter - Implementación del chat usando Firebase Realtime Database
 *
 * Este adaptador mantiene toda la funcionalidad original del chat con Firebase
 */
export class FirebaseChatAdapter extends ChatAdapter {
  CONFIG = {
    apiKey: process.env.REACT_APP_API_URL_BASE_FIREBASE_API_KEY,
    authDomain: process.env.REACT_APP_API_URL_BASE_FIREBASE_AUTH_DOMAIN,
    databaseURL: process.env.REACT_APP_API_URL_BASE_FIREBASE_DATABASE_URL,
    storageBucket: process.env.REACT_APP_API_URL_BASE_FIREBASE_STORAGE_BUCKET,
    messagingSenderId: process.env.REACT_APP_API_URL_BASE_FIREBASE_MESSAGING_SENDER_ID
  };

  /**
   * Inicializa la conexión con Firebase
   * @returns {firebase.app.App} Instancia de Firebase App
   */
  initialize = () => {
    try {
      const fApp = firebase.app('chat');
      return fApp;
    } catch (error) {
      return firebase.initializeApp(this.CONFIG, 'chat');
    }
  }

  /**
   * Envía un mensaje a través de Firebase Realtime Database
   * @param {string} message - Contenido del mensaje
   * @param {number} senderType - Tipo de remitente
   * @param {string} bookingId - ID del booking
   */
  sendMessage = (message, senderType, bookingId) => {
    const init = this.initialize();
    const { key } = init.database()
      .ref()
      .child('chat_messages')
      .child(bookingId)
      .push();

    const chatMessage = {
      message,
      sender: senderType,
      createdAt: firebase.database.ServerValue.TIMESTAMP
    };

    const update = {};
    update['/chat_messages/' + bookingId + '/' + key] = chatMessage;
    init.database().ref().update(update);
  }

  /**
   * Escucha mensajes nuevos en tiempo real desde Firebase
   * @param {string} bookingId - ID del booking
   * @param {Function} onChildAdded - Callback cuando llega un nuevo mensaje
   */
  listenForMessages = (bookingId, onChildAdded) => {
    const init = this.initialize();
    const messagesRef = init.database()
      .ref('chat_messages/' + bookingId)
      .orderByKey();
    messagesRef.on('child_added', (data) => {
      onChildAdded(data.val());
    });
  }

  /**
   * Escucha solo el último mensaje desde Firebase
   * @param {string} bookingId - ID del booking
   * @param {Function} onChildAdded - Callback cuando llega un nuevo mensaje
   */
  listenLastMessages = (bookingId, onChildAdded) => {
    const init = this.initialize();
    const messagesRef = init.database()
      .ref(`chat_messages/${bookingId}`)
      .orderByKey().limitToLast(1);
    messagesRef.on('child_added', (data) => {
      onChildAdded(data.val());
    });
  }

  /**
   * Desconecta los listeners de Firebase
   * @param {string} bookingId - ID del booking
   */
  disconnect = (bookingId) => {
    try {
      const init = this.initialize();
      init.database()
        .ref('chat_messages/' + bookingId)
        .off();
    } catch (error) {
      console.error('Error disconnecting Firebase chat:', error);
    }
  }
}

export default FirebaseChatAdapter;
